<template lang="html">
  <section class="give-star">
    <p class="level-desc">{{ serverDesc }}</p>
    <star
      size="biggest"
      v-on:clickStar="getLevel"
      color="#ff397e"
      :canClick="true"
      :score="level"
    />
  </section>
</template>

<script>
import star from '@/components/common/star'

export default {
  components: {
    star
  },
  props: {
    vorderDetail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      level: 10,
      levelDesc: []
    }
  },
  async created() {
    const descs = await this.$store.dispatch('getReasons')
    this.levelDesc = descs.data.serverStarDesc || []
  },
  methods: {
    getLevel(index) {
      this.level = index
      this.$store.commit('setCommentObj', {
        score: index
      })
      this.$$tracker('110802', '20000', 21065, this.vorderDetail.vorder_id)
    },
    getDesc(arr, index) {
      if (arr && arr[index]) {
        return arr[index]
      }
      return ''
    }
  },
  computed: {
    serverDesc() {
      if (this.levelDesc && this.levelDesc[this.level / 2 - 1]) {
        return `${this.levelDesc[this.level / 2 - 1]}`
      }
      return ''
    }
  }
}
</script>
<style lang="scss">
ul.biggest {
  margin: 0 auto;
}
</style>
<style lang="scss" scoped>
@import '../../../../assets/css/mixin';

.give-star {
  background-color: #fff;
  padding: rem(30px) rem(20px);
  margin-top: rem(10px);
  margin-bottom: rem(10px);
  text-align: center;

  .name {
    font-size: rem(28px);
  }
  .level-desc {
    font-size: rem(28px);
    padding-top: rem(10px);
    padding-bottom: rem(30px);
    font-size: rem(42px);
    color: #121212;
    text-align: center;
  }

  &:last-of-type {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
